// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1_MOO","cls2":"NewsHeader-cls2_Zgl NewsHeader-cls1_MOO"};